/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetMediaExportJobsByIdQueryResponse, WebAppGetMediaExportJobsByIdPathParams, WebAppGetMediaExportJobsById401, WebAppGetMediaExportJobsById403, WebAppGetMediaExportJobsById404 } from "../models/WebAppGetMediaExportJobsById";

export function getWebAppGetMediaExportJobsByIdUrl(id: WebAppGetMediaExportJobsByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/web-app/v1/export-jobs/${id}` as const }
  return res
}

/**
 * @description Returns a single export job for the current user. Result includes fileSize only when completed (no storage URL).
 * @summary Get export job by id
 * {@link /web-app/v1/export-jobs/:id}
 */
export async function webAppGetMediaExportJobsById(id: WebAppGetMediaExportJobsByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetMediaExportJobsByIdQueryResponse, ResponseErrorConfig<WebAppGetMediaExportJobsById401 | WebAppGetMediaExportJobsById403 | WebAppGetMediaExportJobsById404>, unknown>({ method : "GET", url : getWebAppGetMediaExportJobsByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}